import {
  Col,
  message,
  PageHeader,
  Row,
  Spin,
  Select,
  Space,
  Tabs,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  SelectItem,
  Form,
  FormItem,
  RangePickerItem,
  TableItem,
  dineroDisabledMask,
  ButtonItem,
  ErrorItem,
  SwitchItem,
} from "../../../../Components/Items";
import { FileExcelOutlined } from "@ant-design/icons";
import * as XLSXStyle from "xlsx-js-style";
import { ResponsiveLine } from "@nivo/line";
import moment from "moment";
import "moment/locale/es";
import {
  DIAS_SEMANA,
  leerDiaInicioSemanaGuardado,
  guardarDiaInicioSemana,
  leerSepararMaquinariaGuardado,
  guardarSepararMaquinaria,
  leerSepararMaterialesGuardado,
  guardarSepararMateriales,
} from "./diaInicioSemana.utils";

moment.locale("es");

const { Option } = Select;
const { TabPane } = Tabs;

class ReporteCobranzaRealizada extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    objetoClientes: null,
    todasClientes: null,
    objetoProyectos: null,
    todasProyectos: null,
    dataReporte: null,
    semanas: [],
    grupos: [],
    filas: [],
    totalesGeneralesPorSemana: {},
    totalGeneral: 0,
    maquinariaGeneral: 0,
    materialesGeneral: 0,
    meses: [],
    maquinariaGeneralPorMes: {},
    materialesGeneralPorMes: {},
    dataGrafico: [],
    empresa: null,
  };

  atras() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await axios
      .post(
        "clientes/selectClientes",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasClientes: res.data,
            objetoClientes: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.stringBuscar}
              </Option>
            )),
          });
        }
      });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasProyectos: res.data,
            objetoProyectos: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.nombre}
              </Option>
            )),
          });
        }
      });
    this.consultarReporte({
      periodo: [moment().subtract(1, "month"), moment()],
      clientes: 0,
      proyectos: 0,
      diaInicioSemana: leerDiaInicioSemanaGuardado(),
      separarMaquinaria: leerSepararMaquinariaGuardado(),
      separarMateriales: leerSepararMaterialesGuardado(),
    });
  }

  consultarReporte(values) {
    this.setState({ loading: true });
    const diaInicioSemana = values.diaInicioSemana ?? 0;
    const separarMaquinaria = values.separarMaquinaria !== false;
    const separarMateriales = values.separarMateriales !== false;
    guardarDiaInicioSemana(diaInicioSemana);
    guardarSepararMaquinaria(separarMaquinaria);
    guardarSepararMateriales(separarMateriales);
    axios
      .post(
        "reportesAdministrativos/reporteCobranzaPorSemana",
        {
          fechaInicial: values.periodo[0].startOf("day").toISOString(),
          fechaFinal: values.periodo[1].endOf("day").toISOString(),
          clientes: values.clientes || 0,
          proyectos: values.proyectos || 0,
          diaInicioSemana,
          separarMaquinaria,
          separarMateriales,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          const semanas = res.data.semanas || [];
          const grupos = res.data.grupos || [];
          const totalesGeneralesPorSemana = res.data.totalesGeneralesPorSemana || {};
          const totalGeneral = res.data.totalGeneral || 0;
          const maquinariaGeneral = res.data.maquinariaGeneral || 0;
          const materialesGeneral = res.data.materialesGeneral || 0;
          const meses = res.data.meses || [];
          const maquinariaGeneralPorMes = res.data.maquinariaGeneralPorMes || {};
          const materialesGeneralPorMes = res.data.materialesGeneralPorMes || {};

          this.construirFilas(
            grupos,
            totalesGeneralesPorSemana,
            totalGeneral,
            maquinariaGeneral,
            materialesGeneral,
            maquinariaGeneralPorMes,
            materialesGeneralPorMes
          );
          this.crearGrafico(semanas, totalesGeneralesPorSemana);

          this.setState({
            dataReporte: res.data,
            semanas,
            grupos,
            totalesGeneralesPorSemana,
            totalGeneral,
            maquinariaGeneral,
            materialesGeneral,
            meses,
            maquinariaGeneralPorMes,
            materialesGeneralPorMes,
            empresa: res.data.empresa,
            loading: false,
          });
        } else {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        message.error("Ha sucedido un error y no se cargo bien el reporte");
        this.setState({ loading: false });
      });
  }

  construirFilas(
    grupos,
    totalesGeneralesPorSemana,
    totalGeneral,
    maquinariaGeneral,
    materialesGeneral,
    maquinariaGeneralPorMes,
    materialesGeneralPorMes
  ) {
    const filas = [];
    grupos.forEach((grupo) => {
      filas.push({
        isHeader: true,
        key: `header-${grupo.clienteId}-${grupo.proyectoId}`,
        etiqueta: `${grupo.cliente} - ${grupo.proyecto}`,
      });
      (grupo.facturas || []).forEach((factura, idx) => {
        filas.push({
          isDetail: true,
          key: `detalle-${grupo.clienteId}-${grupo.proyectoId}-${idx}`,
          folio: factura.folio,
          montos: factura.montos || {},
          total: factura.total,
          maquinaria: factura.maquinaria || 0,
          materiales: factura.materiales || 0,
          maquinariaPorMes: factura.maquinariaPorMes || {},
          materialesPorMes: factura.materialesPorMes || {},
        });
      });
    });
    if (grupos.length > 0) {
      filas.push({
        isGranTotal: true,
        key: "gran-total",
        montos: totalesGeneralesPorSemana,
        total: totalGeneral,
        maquinaria: maquinariaGeneral,
        materiales: materialesGeneral,
        maquinariaPorMes: maquinariaGeneralPorMes,
        materialesPorMes: materialesGeneralPorMes,
      });
    }
    this.setState({ filas });
  }

  crearGrafico(semanas, totalesGeneralesPorSemana) {
    const data = semanas.map((semana) => ({
      x: semana.label,
      y: totalesGeneralesPorSemana[semana.key] || 0,
    }));
    this.setState({
      dataGrafico: [{ id: "Cobrado", color: "hsl(190, 70%, 45%)", data }],
    });
  }

  descargarExcel() {
    const {
      semanas,
      meses,
      grupos,
      totalesGeneralesPorSemana,
      maquinariaGeneralPorMes,
      materialesGeneralPorMes,
      empresa,
    } = this.state;
    const HEADER_COLOR = "D9D9D9";
    const TOTAL_COLOR = "E6FFFB";
    const MES_COLORS = ["BDD7EE", "8EA9DB"];
    // Formato Contabilidad: el signo de pesos queda pegado al borde izquierdo
    // de la celda y el numero al borde derecho, en vez de ir junto al numero.
    const FORMATO_CONTABILIDAD = '_-"$"* #,##0.00_-;-"$"* #,##0.00_-;_-"$"* "-"??_-;_-@_-';
    const border = {
      top: { style: "thin", color: { auto: 1 } },
      bottom: { style: "thin", color: { auto: 1 } },
      left: { style: "thin", color: { auto: 1 } },
      right: { style: "thin", color: { auto: 1 } },
    };
    const headerStyle = {
      font: { bold: true, sz: 11 },
      fill: { fgColor: { rgb: HEADER_COLOR } },
      alignment: { horizontal: "center", vertical: "center" },
      border,
    };
    const mesStyle = (color) => ({
      font: { bold: true, color: { rgb: "FFFFFF" }, sz: 11 },
      fill: { fgColor: { rgb: color } },
      alignment: { horizontal: "center", vertical: "center" },
      border,
    });
    const semanaStyle = {
      font: { bold: true, sz: 10 },
      fill: { fgColor: { rgb: "F2F2F2" } },
      alignment: { horizontal: "center" },
      border,
    };
    const rangoStyle = {
      font: { sz: 9, color: { rgb: "595959" } },
      fill: { fgColor: { rgb: "F2F2F2" } },
      alignment: { horizontal: "center" },
      border,
    };
    const blankStyle = { fill: { fgColor: { rgb: "F2F2F2" } }, border };
    const groupStyle = {
      font: { bold: true },
      fill: { fgColor: { rgb: TOTAL_COLOR } },
      border,
    };
    const totalStyle = {
      font: { bold: true, sz: 10 },
      fill: { fgColor: { rgb: TOTAL_COLOR } },
      alignment: { horizontal: "right" },
      numFmt: FORMATO_CONTABILIDAD,
      border,
    };
    const moneyStyle = {
      alignment: { horizontal: "right" },
      numFmt: FORMATO_CONTABILIDAD,
      border,
    };
    const plainBorder = { border };
    // xlsx-js-style no infiere el tipo de celda cuando ya se le pasa un
    // objeto { v, s } armado - sin "t" explicito, escribe el numero como
    // texto y Excel no puede aplicarle formato de moneda (queda con el
    // triangulo verde de "numero guardado como texto").
    const celdaMoneda = (valor, estilo) => (valor ? { v: valor, t: "n", s: estilo } : { v: "", s: estilo });

    const totalColumnas = 2 + semanas.length + meses.length * 2;
    const rows = [];
    const merges = [];

    rows.push([
      { v: `COBRANZA POR SEMANA - ${(empresa && empresa.nombre) || ""}`, s: { font: { bold: true, sz: 14 } } },
    ]);
    merges.push({ s: { r: 0, c: 0 }, e: { r: 0, c: totalColumnas - 1 } });

    if (semanas.length > 0) {
      const primera = semanas[0];
      const ultima = semanas[semanas.length - 1];
      rows.push([
        {
          v: `PERIODO: ${primera.mes} ${primera.rango} — ${ultima.mes} ${ultima.rango}`,
          s: { font: { bold: true, sz: 11 } },
        },
      ]);
      merges.push({ s: { r: 1, c: 0 }, e: { r: 1, c: totalColumnas - 1 } });
    } else {
      rows.push([]);
    }

    const filaMesIndex = rows.length;
    const filaMes = [{ v: "", s: blankStyle }, { v: "", s: blankStyle }];
    let colActual = 2;
    let indiceSegmentoMes = 0;
    let i = 0;
    while (i < semanas.length) {
      const mes = semanas[i].mes;
      let j = i;
      while (j < semanas.length && semanas[j].mes === mes) j++;
      const estilo = mesStyle(MES_COLORS[indiceSegmentoMes % MES_COLORS.length]);
      filaMes.push({ v: mes, s: estilo });
      for (let k = i + 1; k < j; k++) filaMes.push({ v: "", s: estilo });
      if (j - i > 1) {
        merges.push({ s: { r: filaMesIndex, c: colActual }, e: { r: filaMesIndex, c: colActual + (j - i - 1) } });
      }
      colActual += j - i;
      indiceSegmentoMes++;
      i = j;
    }
    rows.push(filaMes);

    rows.push([
      { v: "", s: blankStyle },
      { v: "", s: blankStyle },
      ...semanas.map((s) => ({ v: s.label, s: semanaStyle })),
      ...meses.map(() => ({ v: "", s: blankStyle })),
      ...meses.map(() => ({ v: "", s: blankStyle })),
    ]);

    rows.push([
      { v: "", s: blankStyle },
      { v: "", s: blankStyle },
      ...semanas.map((s) => ({ v: s.rango, s: rangoStyle })),
      ...meses.map((mes) => ({ v: mes.label, s: semanaStyle })),
      ...meses.map((mes) => ({ v: mes.label, s: semanaStyle })),
    ]);

    // Maquinaria y materiales se desglosan por el mes en que se cobraron.
    const headerRowIndex = rows.length;
    const colMaquinaria = 2 + semanas.length;
    const colMateriales = colMaquinaria + meses.length;
    const headerRow = [
      { v: "CLIENTE / PROYECTO", s: headerStyle },
      { v: "FACTURA", s: headerStyle },
      ...semanas.map(() => ({ v: "", s: headerStyle })),
      ...meses.map((_, idx) => ({ v: idx === 0 ? "MAQUINARIA" : "", s: headerStyle })),
      ...meses.map((_, idx) => ({ v: idx === 0 ? "MATERIALES" : "", s: headerStyle })),
    ];
    rows.push(headerRow);
    if (meses.length > 1) {
      merges.push({ s: { r: headerRowIndex, c: colMaquinaria }, e: { r: headerRowIndex, c: colMateriales - 1 } });
      merges.push({ s: { r: headerRowIndex, c: colMateriales }, e: { r: headerRowIndex, c: totalColumnas - 1 } });
    }

    grupos.forEach((grupo) => {
      const filaGrupo = [{ v: `${grupo.cliente} - ${grupo.proyecto}`, s: groupStyle }];
      for (let i = 1; i < totalColumnas; i++) {
        filaGrupo.push({ v: "", s: groupStyle });
      }
      rows.push(filaGrupo);

      (grupo.facturas || []).forEach((factura) => {
        rows.push([
          { v: "", s: plainBorder },
          { v: factura.folio || "", s: plainBorder },
          ...semanas.map((s) => celdaMoneda((factura.montos && factura.montos[s.key]) || 0, moneyStyle)),
          ...meses.map((mes) =>
            celdaMoneda((factura.maquinariaPorMes && factura.maquinariaPorMes[mes.key]) || 0, moneyStyle)
          ),
          ...meses.map((mes) =>
            celdaMoneda((factura.materialesPorMes && factura.materialesPorMes[mes.key]) || 0, moneyStyle)
          ),
        ]);
      });
    });

    if (grupos.length > 0) {
      rows.push([
        { v: "TOTALES GENERALES", s: totalStyle },
        { v: "", s: totalStyle },
        ...semanas.map((s) => celdaMoneda(totalesGeneralesPorSemana[s.key] || 0, totalStyle)),
        ...meses.map((mes) => celdaMoneda((maquinariaGeneralPorMes || {})[mes.key] || 0, totalStyle)),
        ...meses.map((mes) => celdaMoneda((materialesGeneralPorMes || {})[mes.key] || 0, totalStyle)),
      ]);
    }

    const worksheet = XLSXStyle.utils.aoa_to_sheet(rows);
    worksheet["!merges"] = merges;
    worksheet["!cols"] = [
      { wch: 32 },
      { wch: 14 },
      ...semanas.map(() => ({ wch: 16 })),
      ...meses.map(() => ({ wch: 16 })),
      ...meses.map(() => ({ wch: 16 })),
    ];
    const workbook = XLSXStyle.utils.book_new();
    XLSXStyle.utils.book_append_sheet(workbook, worksheet, "Cobranza Por Semana");
    XLSXStyle.writeFile(
      workbook,
      `Cobranza_Por_Semana_${moment().locale("es").format("DD-MM-YYYY")}.xlsx`
    );
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  render() {
    const columnasFijas = [
      {
        title: "Cliente / Proyecto",
        dataIndex: "etiqueta",
        key: "etiqueta",
        width: 220,
        fixed: "left",
        ellipsis: true,
        onCell: (record) => ({
          colSpan: record.isHeader ? 2 : 1,
        }),
        render: (value, record) => {
          if (record.isGranTotal) return "TOTALES GENERALES";
          return value;
        },
      },
      {
        title: "Factura",
        dataIndex: "folio",
        key: "folio",
        width: 120,
        fixed: "left",
        ellipsis: true,
        onCell: (record) => ({
          colSpan: record.isHeader ? 0 : 1,
        }),
      },
    ];

    const columnasSemanas = this.state.semanas.map((semana) => ({
      title: () => (
        <div style={{ textAlign: "center" }}>
          <div>{semana.label}</div>
          <div style={{ fontSize: 11, fontWeight: 400 }}>{semana.rango}</div>
        </div>
      ),
      dataIndex: ["montos", semana.key],
      key: semana.key,
      align: "right",
      width: 130,
      onCell: (record) => ({
        colSpan: record.isHeader ? 0 : 1,
      }),
      render: (value, record) => (record.isHeader ? "" : dineroDisabledMask(value || 0)),
    }));

    const columnaSeparadaPorMes = (titulo, campo) => ({
      title: () => <div style={{ textAlign: "center" }}>{titulo}</div>,
      key: campo,
      align: "center",
      children: this.state.meses.map((mes) => ({
        title: mes.label,
        dataIndex: [campo, mes.key],
        key: `${campo}-${mes.key}`,
        align: "right",
        width: 130,
        onCell: (record) => ({
          colSpan: record.isHeader ? 0 : 1,
        }),
        render: (value, record) => (record.isHeader ? "" : dineroDisabledMask(value || 0)),
      })),
    });

    const columnaMaquinaria = columnaSeparadaPorMes("Maquinaria", "maquinariaPorMes");
    const columnaMateriales = columnaSeparadaPorMes("Materiales", "materialesPorMes");

    const columns = [...columnasFijas, ...columnasSemanas, columnaMaquinaria, columnaMateriales];

    return (
      <>
        <Form
          ref={this.formRef}
          name="reporteCobranzaPorSemana"
          onFinish={this.consultarReporte.bind(this)}
          onFinishFailed={this.onFinishFailed}
          initialValues={{
            periodo: [moment().subtract(1, "month"), moment()],
            diaInicioSemana: leerDiaInicioSemanaGuardado(),
            separarMaquinaria: leerSepararMaquinariaGuardado(),
            separarMateriales: leerSepararMaterialesGuardado(),
          }}
        >
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Reporte Cobranza Por Semana"
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
            extra={
              <div style={{ display: "flex", justifyContent: "right" }}>
                <Space>
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarExcel()}
                      icon={<FileExcelOutlined />}
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Descargar Excel
                    </ButtonItem>
                  )}
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Consultar
                  </ButtonItem>
                </Space>
              </div>
            }
          />
          <Spin spinning={this.state.loading}>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 5,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <Tabs
                style={{ margin: 0 }}
                tabBarExtraContent={{
                  left: (
                    <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>Filtros:</h1>
                  ),
                }}
              >
                <TabPane tabKey="1" key="1" forceRender tab="Periodo">
                  <FormItem name="periodo" required noStyle>
                    <RangePickerItem />
                  </FormItem>
                </TabPane>
                <TabPane tabKey="2" key="2" forceRender tab="Clientes">
                  <FormItem name="clientes" noStyle margin>
                    <SelectItem width="90%" mode="multiple" placeholder="Clientes">
                      {this.state.objetoClientes}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="3" key="3" forceRender tab="Proyectos">
                  <FormItem name="proyectos" noStyle margin>
                    <SelectItem width="90%" mode="multiple" placeholder="Proyectos">
                      {this.state.objetoProyectos}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="4" key="4" forceRender tab="Semana">
                  <FormItem name="diaInicioSemana" noStyle margin>
                    <SelectItem width="90%" placeholder="Día de inicio de semana">
                      {DIAS_SEMANA.map((dia) => (
                        <Option value={dia.value} key={dia.value}>
                          {dia.label}
                        </Option>
                      ))}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="5" key="5" forceRender tab="Separar">
                  <FormItem
                    label="Separar Renta de Maquinaria"
                    name="separarMaquinaria"
                    valuePropName="checked"
                    margin
                  >
                    <SwitchItem />
                  </FormItem>
                  <FormItem
                    label="Separar Suministro de Materiales"
                    name="separarMateriales"
                    valuePropName="checked"
                    margin
                  >
                    <SwitchItem />
                  </FormItem>
                </TabPane>
              </Tabs>
            </div>

            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingBottom: 35,
                marginTop: 10,
                marginBottom: 10,
                height: 420,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <h1 style={{ fontSize: 18, margin: 0, marginBottom: 10 }}>
                Cobrado por semana
              </h1>
              <ResponsiveLine
                data={this.state.dataGrafico}
                margin={{ top: 15, right: 20, bottom: 70, left: 100 }}
                enableSlices="x"
                useMesh={true}
                yFormat={(e) => dineroDisabledMask(Math.abs(e))}
                xScale={{ type: "point" }}
                yScale={{
                  type: "linear",
                  min: 0,
                  max: "auto",
                  stacked: false,
                  reverse: false,
                }}
                curve="monotoneX"
                lineWidth={2}
                pointSize={5}
                pointBorderWidth={1}
                pointColor={{ theme: "background" }}
                pointBorderColor={{ from: "serieColor" }}
                colors={["#00BFD6"]}
                colorBy="index"
                axisTop={null}
                axisRight={null}
                axisBottom={{
                  tickSize: 5,
                  tickPadding: 8,
                  tickRotation: 45,
                  tickValues: (this.state.dataGrafico?.[0]?.data || [])
                    .map((d) => d.x)
                    .filter((_, i) => i % 2 === 0),
                }}
                axisLeft={{
                  tickSize: 5,
                  tickPadding: 8,
                  format: (v) => dineroDisabledMask(Math.abs(v)),
                }}
                enableGridX={false}
                legends={[
                  {
                    anchor: "top-right",
                    direction: "column",
                    translateX: 0,
                    translateY: 0,
                    itemWidth: 130,
                    itemHeight: 18,
                    symbolSize: 10,
                    symbolShape: "circle",
                    itemOpacity: 0.85,
                    effects: [{ on: "hover", style: { itemOpacity: 1 } }],
                  },
                ]}
              />
            </div>

            <div
              style={{
                backgroundColor: "white",
                padding: 15,
                marginBottom: 10,
                height: "75px",
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <Row>
                <Col span={24} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Total Cobrado</p>
                  <h1 style={{ fontSize: 15 }}>
                    {dineroDisabledMask(this.state.totalGeneral)}
                  </h1>
                </Col>
              </Row>
            </div>

            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 5,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <TableItem
                rowKey="key"
                columns={columns}
                dataSource={this.state.filas}
                size="small"
                pagination={false}
                scroll={{ x: "max-content" }}
                rowClassName={(record) =>
                  record.isHeader
                    ? "fila-grupo-cobranza"
                    : record.isGranTotal
                    ? "fila-total-cobranza"
                    : ""
                }
              />
            </div>
          </Spin>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ReporteCobranzaRealizada);
